// Índice de documentos de la categoría: Comienzo
import primer_flujo from './primer-flujo.js';
import como_comenzar_aplicacion from './como-comenzar-aplicacion.js';

const comienzoDocs = [
  primer_flujo,
  como_comenzar_aplicacion,
];

export default comienzoDocs;
